import * as _ from 'lodash';
import IZoningCodesImportValidationResult = ZoneIQCalibration.IZoningCodesImportValidationResult;
import IBaseImportValidationResult = ZoneIQCalibration.IBaseImportValidationResult;
import IZoningCodeImportRowData = ZoneIQCalibration.IZoningCodeImportRowData;
import { IZCValidationTableResult } from 'src/app/interfaces/zc-validation-result.interface';

const properties = ['zoningCodesRows', 'importValidationResult'];

export interface IZoningCodesImportValidationResultModel extends IZoningCodesImportValidationResult {
    messages?: IZCValidationTableResult[];
}

export class ZoningCodesImportValidationResultModel implements IZoningCodesImportValidationResultModel {
    zoningCodesRows: IZoningCodeImportRowData[];
    importValidationResult: IBaseImportValidationResult;
    messages?: IZCValidationTableResult[] = [];

    constructor(data: IZoningCodesImportValidationResult) {
        Object.assign(this, _.pick(data, properties));
    }
}
